import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-sick-leave",
  templateUrl: "./sick-leave.component.html"
})
export class SickLeaveComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService) {
    this.jsLoader.loadScripts();
  }

  ngOnInit() {}
}
